import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svgformato',
  templateUrl: './svgformato.component.html',
  styleUrls: ['./svgformato.component.css']
})
export class SvgformatoComponent implements OnInit {
 
  @Input() color: string;
  constructor() { }

  ngOnInit() {
  }

}
